import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SourceService } from './source.service';

@Injectable({
  providedIn: 'root'
})
export class SourceResolve {

  constructor(
    private ss: SourceService,
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.ss.updateSource(route.params.id)
  }
}
